import { render } from "./approvalRequest.vue?vue&type=template&id=06200a1a"
import script from "./approvalRequest.vue?vue&type=script&lang=js"
export * from "./approvalRequest.vue?vue&type=script&lang=js"

import "./approvalRequest.vue?vue&type=style&index=0&id=06200a1a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__